export default __webpack_public_path__ + "static/masteryMethodology-71e388aa833e684047cef07fbce316bf.png";